import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui';
import router from '../router/index';
axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
  return config;
}, function (err) {
  errorState(err)
})

axios.interceptors.response.use(function (res) {
  if (res.status === 200) {
    // 响应拦截器
    if (res.data.code == '200' || res.data.code == '501') {
      if (res.config.method == 'post') {
        return Promise.resolve(res);
      } else {
        return Promise.resolve(res.data);
      }
    } else if (res.data.code == '600') {
      if (window.location.href.indexOf("localhost") > -1) {
        router.push('/login')
      }else if (window.location.href.indexOf("testhyt") > -1) {
        //测试环境
        router.push('/login')
      }  else {
        //正式环境
        location.href = "https://yz.yqcrm.cn/login"; //正式环境
      }
      return Promise.reject(res.data)
    } else {
      Message.error(res.data.message);
      return Promise.reject(false);
    }

  } else {
    Message.error(res.statusText)
  }
}, function (err) {
  errorState(err);
});


function errorState(err) {
  if (String(err).indexOf('600') != -1) {
    location.href = "https://oauth.taobao.com/authorize?response_type=code&client_id=12666072&redirect_uri=http%3A%2F%2Fdxe.yusms.com%2Ftblogin.do&state=leaseId%3A0%3BitemCode%3Ats-131195-1%3Bscope%3Ar1%2Cr2%2Cw1%2Cw2%3BversionNo%3A2%3Bsign%3AE312C246EF847BC54552CB5D84AAB41B%3Bouter_trade_code%3A%3Btimestamp%3A1551771643881&from_site=fuwu"
  } else {
    var e = (err + '').indexOf('timeout') > -1 ? '请求超时' : err + '';
    Message.error(e);
    return err;
  }

}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  });
}

export function getType1(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url + params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function imagePost(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * postJson方法，对应post请求
 * body请求体
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postJson(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteApi(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, { params: params })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 */
export function put(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.put(url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 */
export function putJson(url, params) {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
